import {
	comMapping
} from "@/components/util/Function/comMapping";
export function getdata() {
	let obj = {
		searchlist: [{
				prop: "nasrmc",
				label: '纳税人名称',
				type: "input",
			},
			{
				prop: "nsrsbh",
				label: '纳税人识别号',
				type: "select",
				type: "input",
			}, {
				prop: "gongsbh",
				label: '公司编号',
				type: "select",
				type: "input",
			},
		],
		searchdata: {
			nasrmc: '',
			nsrsbh: '',
			gongsbh: '',
		},
		headData: [{
				title: "纳税人名称",
				prop: "nasrmc",
				width: "100"
			},
			{
				title: "企业编号",
				prop: "accountDesc",
				width: "100",

			},
			{
				title: "纳税人识别号",
				prop: "nsrsbh",
				width: "100",
			},
			{
				title: "公司编号",
				prop: "gongsbh",
				width: "100",
			},
		],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
	}
	return obj
}
